import { render, staticRenderFns } from "./IconTransfer.vue?vue&type=template&id=4bb6296b&functional=true&"
import script from "./IconTransfer.vue?vue&type=script&lang=js&"
export * from "./IconTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports